import { type TriggerTargetSpec } from "@/shared/domain/triggers";
import { useTriggerDispatches } from "@/shared/domain/triggers/hooks";

import { TriggerDispatchesTable } from "./TriggerDispatchesTable";

/** Dispatch history for one trigger, newest first. */
export function TriggerDispatchesForTrigger({
  triggerId,
  targets,
}: {
  triggerId: string;
  /** The trigger's current targets, so the Target column can name them. */
  targets?: readonly TriggerTargetSpec[];
}) {
  const query = useTriggerDispatches(triggerId);
  return <TriggerDispatchesTable query={query} targets={targets} />;
}
